export enum ConversionType {
    REFINANCE = 'REFINANCE',
    OPPORTUNITY_REFINANCE = 'OPPORTUNITY_REFINANCE',
    OPPORTUNITY_ACTION_REFINANCE = 'OPPORTUNITY_ACTION_REFINANCE',
    CAMPAIGN_REFINANCE = 'CAMPAIGN_REFINANCE'

}

export const ALL_CONVERSION_TYPES = ():ConversionType[] => {
    let types = [];
    for (let conversionType in ConversionType) {
        types.push(conversionType);
    }
    return types;
};